import axiosInstance from "@/api/axios-instance";
import { ConsentFormStatus } from "@/pages/users/types/user";

export async function updateUserDetails({
  user_id,
  name,
  email,
  phone_number,
  country,
  age,
  language,
  sex,
  document_ids,
  hrc_status,
  mc_status,
  risk_category,
  is_test_user,
  allow_onboarding_flow,
  region_id,
}: {
  user_id: string;
  name?: string | null;
  email?: string | null;
  phone_number?: string | null;
  country?: string | null;
  age?: number | null;
  language?: string[] | null;
  sex?: string | null;
  document_ids?: Record<string, string> | null;
  hrc_status?: ConsentFormStatus | undefined;
  mc_status?: ConsentFormStatus;
  risk_category?: string | null;
  is_test_user?: boolean;
  allow_onboarding_flow?: boolean;
  region_id?: string | null;
}) {
  const response = await axiosInstance.patch(`/users/update-user-details`, {
    user_id,
    name,
    email,
    phone_number,
    country,
    age,
    language,
    sex,
    document_ids,
    hrc_status,
    mc_status,
    risk_category,
    is_test_user,
    allow_onboarding_flow,
    region_id,
  });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("Failed to update user details");
  }

  return response.data;
}
